<template>
    <div>
        <a href="#" class="is-align-center is-space-between p-r-none" @click.prevent="isTemplatePreviewOpen = true; closeMenu()">
            {{ item.text }}

            <template v-if="locked">
                <locked-item
                    v-if="hasPrerequisite"
                    :item="{
                        type: 'prerequisite',
                        namespace: 'activity_template',
                        position: 'is-right',
                        prereqTitle,
                    }"
                />

                <locked-item
                    v-else
                    :item="{
                        type: 'visibleAt',
                        namespace: 'activity_template',
                        visibleAt: titleText,
                        position: 'is-right',
                    }"
                />
            </template>
        </a>

        <teleport to="body">
            <e-modal v-model="isTemplatePreviewOpen" scroll="keep" has-modal-card :can-cancel="false">
                <template-preview :uuid="item.uuid" :parent-title="item.title" is-template @close="isTemplatePreviewOpen = false" />
            </e-modal>
        </teleport>
    </div>
</template>

<script>
import TemplatePreview from '@/components/modals/template-preview/TemplatePreview.vue';
import LockedItem from '@/components/nested-list/LockedItem.vue';
import SidebarMixin from '@/mixins/Sidebar.mixin.js';
import CourseTemplateMenuItem from '@/models/CourseTemplateMenuItem.js';

export default {
    name: 'ActivityTemplate',

    components: { TemplatePreview, LockedItem },

    mixins: [SidebarMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            type: CourseTemplateMenuItem,
            required: true,
        },
    },

    data: () => ({
        isTemplatePreviewOpen: false,
    }),
};
</script>
